<template>
  <el-popover
    v-model="visible"
    placement="right"
    trigger="manual"
    :disabled="!oldData && !newData"
  >
    <el-button
      slot="reference"
      type="text"
      :loading="loading"
      style="color: #4071ff"
      @click="handleActive"
    >
      预 览
    </el-button>
    <div class="preview-content" :class="{ single: isSingle }">
      <el-card v-if="oldData" class="before">
        <div slot="header">
          <span>修改前歌词</span>
          <a class="download-btn" :href="$toProtocolRelative(oldData.lyricUrl)" target="_blank">文件下载</a>
        </div>
        <pre class="lyric-text">{{ beforeLyricText }}</pre>
      </el-card>
      <el-card v-if="newData" class="after">
        <div slot="header">
          <span>修改后歌词</span>
          <a class="download-btn" :href="$toProtocolRelative(newData.lyricUrl)" target="_blank">文件下载</a>
        </div>
        <pre class="lyric-text">{{ afterLyricText }}</pre>
      </el-card>
    </div>
  </el-popover>
</template>

<script>

// 本地缓存
const memMap = new Map()

export default {
  name: 'LyricPreview',
  props: {
    oldData: [Object, String],
    newData: [Object, String]
  },
  data() {
    return {
      visible: false,
      loading: false,
      beforeLyricText: '',
      afterLyricText: '',
      requestSucceed: false
    }
  },
  computed: {
    isSingle() {
      return !this.oldData || !this.newData
    }
  },
  mounted() {
    // 监听页面点击事件，点击非 popover 区域时关闭 popover
    document.addEventListener('click', this.popoverHandler)
  },
  destroyed() {
    document.removeEventListener('click', this.popoverHandler)
  },
  methods: {
    popoverHandler(e) {
      if (this.visible && !this.$el.contains(e.target)) {
        this.visible = false
      }
    },
    requestLyricText(url) {
      if (memMap.has(url)) {
        return Promise.resolve(memMap.get(url))
      }

      return fetch(this.$toPreview(url)).then(response => response.text())
    },
    async getLyricText() {
      if (this.requestSucceed) return

      this.loading = true
      try {
        if (this.oldData) {
          const text = await this.requestLyricText(this.oldData.lyricUrl)
          this.beforeLyricText = text
          memMap.set(this.oldData.lyricUrl, text)
        }
        if (this.newData) {
          const text = await this.requestLyricText(this.newData.lyricUrl)
          this.afterLyricText = text
          memMap.set(this.newData.lyricUrl, text)
        }
        this.requestSucceed = true
        this.loading = false
      } catch (error) {
        this.$message.error(error.message)
      }
    },
    async handleActive() {
      if (!this.visible) {
        await this.getLyricText()
        this.requestSucceed && (this.visible = true)
      } else {
        this.visible = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.preview-content {
    width: 800px;
    height: 600px;
    overflow-y: auto;
    display: flex;
    justify-content: space-between;

    &.single {
      width: 400px;

      .before,.after {
        width: 100%;
      }
    }

    .before,.after {
      width: 49%;
      border: none;
      box-shadow: none;

      /deep/ .el-card__body {
        height: calc(100% - 40px);
        overflow: auto;
      }

      .download-btn {
        float: right;
        font-size: 14px;
      }

      .lyric-text {
        width: max-content;
      }
    }
}
</style>
